import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/finance/qrcode.png'
import _imports_1 from '@/assets/finance/pay-wechat.svg'
import _imports_2 from '@/assets/finance/pay-alipay.svg'
import _imports_3 from '@/assets/finance/pay-union-pay.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", { class: "topUpQrcodeModal__amount" }, [
  /*#__PURE__*/_createTextVNode(" 充值金额 "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("¥ "),
    /*#__PURE__*/_createElementVNode("span", null, "1000"),
    /*#__PURE__*/_createTextVNode(" 元")
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "请在30分钟内支付完成", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "topUpQrcodeModal__qrcode",
  src: _imports_0,
  alt: "Qrcode"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "点击刷新二维码", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "请使用微信、支付宝、银联扫码支付", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "topUpQrcodeModal__icons" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Wechat"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Alipay"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "UnionPay"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    class: "topUpQrcodeModal",
    title: "扫码支付",
    style: {width: '800px'},
    footer: null,
    onOk: _ctx.handleOk
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createVNode(_component_a_button, { type: "link" }, {
        default: _withCtx(() => [
          _createTextVNode("我已经支付")
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "onOk"]))
}